export const setLatLonCoordinates = (dataArray, coordinates) => {
  const array = dataArray.map((obj) => {
    const element = coordinates[obj.y][obj.x];
    switch (obj.x) {
      case 1:
        return {
          corners: [element.tl, element.tr, element.br, element.bl],
          value: obj.value,
        };
      case 0:
        return null;
      default:
        return {
          corners: [
            coordinates[obj.y][obj.x - 1].tr,
            element.tr,
            element.br,
            coordinates[obj.y][obj.x - 1].br,
          ],
          value: obj.value,
        };
    }
  });
  return array.filter((obj) => obj);
};

export const roundToPrecision = (number, precision) => {
  const result = number.toFixed(precision);
  return parseFloat(result);
};

export const formatTableValue = (num, precision, len = 1, signed = true) => {
  const result = Number(
    Math.sign(num) *
      (+`${Math.round(
        +`${Math.abs(num)}e${precision}`
      )}e${-precision}`).toFixed(precision)
  );
  const sign = signed && result > 0 ? '+' : '';

  return result.toFixed(len).replace(/^/, sign).replace(/\./g, ',');
};

export const getMovingAverage = (array) => {
  const filteredArray = array.filter(
    (item) => item.timestamp >= 1965 && item.timestamp < 2005
  );

  return filteredArray.map((item, i) => {
    let arraySum = 0;
    const min = parseInt(i, 10);
    const max = parseInt(i, 10) + 30;
    const observedArray = array.slice(min, max);
    observedArray.forEach((obj) => {
      arraySum += parseFloat(obj.value);
    });
    const averageValue = arraySum / 30;
    return { timestamp: item.timestamp, value: averageValue.toFixed(2) };
  });
};

export const getDateString = () => {
  const today = new Date();
  const dd = String(today.getDate()).padStart(2, '0');
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const yyyy = today.getFullYear();

  const dateString = `${dd}.${mm}.${yyyy}`;
  return dateString;
};

export default {};
